import { render, staticRenderFns } from "./MPRInteractor.vue?vue&type=template&id=9b8b339c&scoped=true&"
import script from "./MPRInteractor.vue?vue&type=script&lang=js&"
export * from "./MPRInteractor.vue?vue&type=script&lang=js&"
import style0 from "./MPRInteractor.vue?vue&type=style&index=0&id=9b8b339c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8b339c",
  null
  
)

export default component.exports